"use strict";

const MuniOutfallsFilters = function () {
  const searchFields = ["outfallName", "address"];
  const searchDbFields = ["outfall_name", "address"];

  var filterResourceDataHandler = async function (
    unfilteredData,
    filters,
    loadingScreen,
    smartFilters,
  ) {
    if (onlineFilterIsSet(filters)) {
      try {
        return await ResourceFilters.filterOnline(
          unfilteredData,
          loadingScreen,
          MuniOutfallsGeoServerLayer.getLayerData,
        );
      } catch (e) {
        ApiError.assertIs(e);
      }
    }

    return filterOffline(unfilteredData, filters, smartFilters);
  };

  var filterOffline = function (unfilteredData, filters, smartFilters) {
    if (DataViewFunctions.getCurrentDataViewProperty("smartToDoFilters") || !filters.toDoFilters) {
      return smartFilters.filter(unfilteredData, filters);
    } else {
      return unfilteredData.filter((datum) => {
        return ResourceFilters.passToDoFilters(datum, filters, toDoFilters, smartFilters);
      });
    }
  };

  var resetTodoFilter = function () {
    Filters.resetToDoFiltersByDataView("muni-outfalls");
  };

  var passDataTabMaintainerTypeFilter = function (datum, filters) {
    let pass = true;

    const maintainerType = !datum.maintainerType ? "null" : datum.maintainerType;
    if (filters.responsiblePartyMaintenance?.length !== undefined) {
      pass = filters.responsiblePartyMaintenance.includes(maintainerType);
    }
    return pass;
  };

  var passDataTabLandOwnershipFilter = function (datum, filters) {
    let pass = true;

    const landOwnership = !datum.landOwnership ? "null" : datum.landOwnership;
    if (filters.landOwnership?.length !== undefined) {
      pass = filters.landOwnership.includes(landOwnership);
    }
    return pass;
  };

  var passOutfallTypeFilter = function (datum, filters) {
    let pass = true;

    const outfallType = !datum.outfallType ? "null" : datum.outfallType;
    if (filters.outfallType?.length !== undefined) {
      pass = filters.outfallType.includes(outfallType);
    }
    return pass;
  };

  var passDataTabOutletTypeFilter = function (datum, filters) {
    let pass = true;

    const outletType = !datum.outletType ? "null" : datum.outletType;
    if (filters.outletType?.length) {
      pass = filters.outletType.includes(outletType);
    }
    return pass;
  };

  var passDataTabConsequenceOfFailureFilter = function (datum, filters) {
    let pass = true;

    const cof = !datum.cof ? "null" : datum.cof;
    if (filters.cof?.length) {
      pass = filters.cof.includes(cof);
    }
    return pass;
  };

  var addGeoServerFilterQuery = function (queryStrings, filters) {
    if (filters.searchString) {
      queryStrings.push(
        GeoServerFilterFunctions.getSearchQuery(searchDbFields, filters.searchString),
      );
    }

    GeoServerFilterFunctions.addGeographicalFocusFiltersToQuery(filters, queryStrings);

    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "implementerType",
      "implementer_type",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "responsiblePartyMaintenance",
      "maintainer_type",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "landOwnership",
      "property",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "outfallType",
      "outfall_type",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "outletType",
      "outlet_type",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "implementationPhase",
      "phase",
    );
    GeoServerFilterFunctions.addMuniConditionFilterToGeoServerQuery(queryStrings, filters);
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "cof",
      "cof_final_text",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "shape",
      "outlet_shape",
    );
    const lengthWidthQueries = [];
    const diameterQuery = [];
    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "outlet_diameter",
      filters.diameterRange,
      "outlet_diameter_units",
      diameterQuery,
    );
    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "outlet_length",
      filters.lengthRange,
      "outlet_length_units",
      lengthWidthQueries,
    );
    GeoServerFilterFunctions.addFeetAndInchesMinMaxMeasurmentQuery(
      "outlet_width",
      filters.widthRange,
      "outlet_width_units",
      lengthWidthQueries,
    );
    const shapeDbColumnName = "outlet_shape";
    const indexOfShapeQuery = MeasurementMinMax.findIndexOfShapeQuery(
      queryStrings,
      shapeDbColumnName,
    );
    GeoServerFilterFunctions.createMinMaxMeasurmentCombinedQuery(
      queryStrings,
      lengthWidthQueries,
      diameterQuery,
      indexOfShapeQuery,
      shapeDbColumnName,
      filters,
    );
    addInstalledDateFilterToGeoServerQuery(queryStrings, filters);
  };

  var addInstalledDateFilterToGeoServerQuery = function (queryStrings, filters) {
    if (filters.installDate) {
      GeoServerFilterFunctions.addDateQuery(
        queryStrings,
        "install_date",
        filters.installDate?.from,
        filters.installDate?.to,
      );
    }
  };

  var onlineFilterIsSet = function (filters) {
    if (filters.toDoFilters) {
      return ResourceFilters.toDoSpatialFiltersAreSet(filters.toDoFilters);
    } else {
      return ResourceFilters.spatialFiltersAreSet(filters);
    }
  };

  var addGeoServerViewParams = function (params, filters) {
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction")) {
      GeoServerFilterFunctions.addAdditionalInfoParams(
        filters,
        params,
        "routineRepair",
        true,
        false,
      );
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("correctiveAction") &&
      $('input[name="correctiveAction"][value="no-action"]').is(":checked")
    ) {
      params[`includeNoAction`] = true;
    }
    if (!SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel")) {
      GeoServerFilterFunctions.addAdditionalInfoParams(
        filters,
        params,
        "enforcementLevel",
        false,
        true,
      );
    }
    if (
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("enforcementLevel") &&
      $('input[name="enforcementLevel"][value="null"]').is(":checked")
    ) {
      params[`includeNoActionLevel`] = true;
    }
    ResourceFilters.addDateParam(
      params,
      "routine",
      filters.routineDate?.from,
      filters.routineDate?.to,
    );
    ResourceFilters.addDateParam(
      params,
      "repair",
      filters.repairDate?.from,
      filters.repairDate?.to,
    );
  };

  var toDoFilters = function (datum, subjectFilters, subject) {
    return (
      passDueDateFilter(datum, subjectFilters, subject) &&
      passImplementerTypeFilter(datum, subjectFilters) &&
      passMaintainerTypeFilter(datum, subjectFilters) &&
      passOutletTypeFilter(datum, subjectFilters) &&
      passConsequenceOfFailureFilter(datum, subjectFilters)
    );
  };

  var passImplementerTypeFilter = function (datum, filters) {
    if (filters.implementerType?.length !== undefined) {
      return filters.implementerType.includes(datum.implementerType ?? "unknown");
    }

    return true;
  };

  var passMaintainerTypeFilter = function (datum, filters) {
    if (filters.maintainerType?.length !== undefined) {
      return filters.maintainerType.includes(datum.maintainerType ?? "unknown");
    }

    return true;
  };

  var passOutletTypeFilter = function (datum, filters) {
    const outletTypes = getAllOutletTypes();

    return ResourceFilters.passUnknownWhiteListFilter(
      datum.outletType,
      filters.outletType,
      outletTypes,
    );
  };

  var getAllOutletTypes = function () {
    return OutfallInspectionConstants.addInspectionToDoFilterOptions({}).typeOptions.map(
      (option) => option.value,
    );
  };

  var passConsequenceOfFailureFilter = function (datum, filters) {
    return ResourceFilters.passUnknownWhiteListFilter(datum.cof, filters.consequenceOfFailure, [
      "very-high",
      "high",
      "moderate",
      "low",
      "very-low",
    ]);
  };

  var passDueDateFilter = function (datum, filters, subject) {
    return ResourceFilters.passIsoDateFilter(
      datum[subject]?.dueDate,
      filters.dueDateFrom,
      filters.dueDateTo,
    );
  };

  var addToDoGeoServerFilterQuery = function (subjectStrings, filters) {
    addOutletTypeQuery(subjectStrings, filters);
    addMaintainerTypeQuery(subjectStrings, filters);
    addImplementerTypeQuery(subjectStrings, filters);
    addConsequenceOfFailureQuery(subjectStrings, filters);
  };

  var addOutletTypeQuery = function (queryStrings, filters) {
    if (!Array.isArray(filters.outletType)) {
      return;
    }

    const outletTypes = getAllOutletTypes();
    queryStrings.push(
      GeoServerFilterFunctions.getInArrayQuery("outlet_type", filters.outletType, outletTypes),
    );
  };

  var addMaintainerTypeQuery = function (queryStrings, filters) {
    if (!Array.isArray(filters.maintainerType)) {
      return;
    }

    queryStrings.push(
      GeoServerFilterFunctions.getInArrayQuery("maintainer_type", filters.maintainerType),
    );
  };

  var addImplementerTypeQuery = function (queryStrings, filters) {
    if (!Array.isArray(filters.implementerType)) {
      return;
    }

    queryStrings.push(
      GeoServerFilterFunctions.getInArrayQuery("implementer_type", filters.implementerType),
    );
  };

  var addConsequenceOfFailureQuery = function (queryStrings, filters) {
    if (!Array.isArray(filters.consequenceOfFailure)) {
      return;
    }
    if (filters.consequenceOfFailure?.length !== undefined) {
      queryStrings.push(
        GeoServerFilterFunctions.getInArrayQuery("cof_final_text", filters.consequenceOfFailure, [
          "very-high",
          "high",
          "moderate",
          "low",
          "very-low",
        ]),
      );
    }
  };

  var getFilterConfigs = function () {
    return {
      subGroups: "groupId",
      implementerType: "implementerType",
      responsiblePartyMaintenance: "maintainerType",
      landOwnership: "landOwnership",
      outfallType: "outfallType",
      outletType: "outletType",
      implementationPhase: "phase",
      condition: "condition",
      cof: "cof",
      drainsToRw: "drains_to_rw",
      drainsToC: "drains_to_c",
      catchmentName: "catchment_name",
      zones: "zone_names",
      correctiveAction: ["correctiveAction", "array"],
      enforcementLevel: ["enforcementLevel", "array"],
      shape: "outletShape",
      routineDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.routine,
          filters.routineDate?.from,
          filters.routineDate?.to,
        ),
      repairDate: (datum, filters) =>
        ResourceFilters.passDatesFilter(
          datum.repair,
          filters.repairDate?.from,
          filters.repairDate?.to,
        ),
      ...ResourceFilters.getSmartToDoFilters(),
      otherFilters: (datum, filters) => {
        return (
          ResourceFilters.passSearchStringFilter(datum, filters, searchFields) &&
          MeasurementMinMax.passDiameterFilter(
            datum.outletShape,
            filters.shape,
            datum.outletDiameter,
            datum.outletDiameterUnits,
            { max: filters.diameterRange?.max, min: filters.diameterRange?.min },
          ) &&
          MeasurementMinMax.passLengthWidthFilter(
            datum.outletShape,
            filters.shape,
            datum.outletLength,
            datum.outletLengthUnits,
            datum.outletWidth,
            datum.outletWidthUnits,
            { max: filters.lengthRange?.max, min: filters.lengthRange?.min },
            { max: filters.widthRange?.max, min: filters.widthRange?.min },
          ) &&
          ResourceFilters.passIsoDateFilter(
            datum.installDate,
            filters.installDate?.from,
            filters.installDate?.to,
          )
        );
      },
    };
  };

  return {
    filterResourceDataHandler,
    addToDoGeoServerFilterQuery,
    addGeoServerFilterQuery,
    passDataTabMaintainerTypeFilter,
    passDataTabLandOwnershipFilter,
    passOutfallTypeFilter,
    passDataTabOutletTypeFilter,
    passDataTabConsequenceOfFailureFilter,
    addInstalledDateFilterToGeoServerQuery,
    resetTodoFilter,
    addGeoServerViewParams,
    getFilterConfigs,
  };
};

module.exports = MuniOutfallsFilters();

const ApiError = require("../../errors/apiError");
const DataViewFunctions = require("../../dataViewFunctions");
const Filters = require("../../mapFunctions/filters");
const GeoServerFilterFunctions = require("../../mapFunctions/geoServerFilterFunctions");
const MeasurementMinMax = require("../../general/measurementMinMax");
const MuniOutfallsGeoServerLayer = require("./muniOutfallsGeoServerLayer");
const OutfallInspectionConstants = require("../../outfalls/outfallInspectionConstants");
const ResourceFilters = require("../../filters/resourceFilters");
const SmartFilterRegistry = require("../../filters/smartFilterRegistry");
